// export default window._env_ || {};

// ✅ runtimeEnv.js
const Env = {
  REACT_APP_COGNITO_USER_POOL_ID:
    (window._env_ && window._env_.REACT_APP_COGNITO_USER_POOL_ID) ||
    process.env.REACT_APP_COGNITO_USER_POOL_ID,

  REACT_APP_COGNITO_CLIENT_ID:
    (window._env_ && window._env_.REACT_APP_COGNITO_CLIENT_ID) ||
    process.env.REACT_APP_COGNITO_CLIENT_ID,

  REACT_APP_API_URL:
    (window._env_ && window._env_.REACT_APP_API_URL) ||
    process.env.REACT_APP_API_URL,

  REACT_APP_PYTHON_API_URL:
    (window._env_ && window._env_.REACT_APP_PYTHON_API_URL) ||
    process.env.REACT_APP_PYTHON_API_URL,
};

export default Env;
